import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

const WhySwitchSection = styled.section`
  padding: 40px 0 40px 0;
  background: var(--light-color);
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const SectionTitle = styled.div`
  text-align: center;
  margin-bottom: 60px;

  h2 {
    font-size: 36px;
    color: var(--dark-color);
    margin-bottom: 20px;
    font-weight: 700;
  }

  p {
    font-size: 18px;
    color: #666;
    max-width: 600px;
    margin: 0 auto;
  }
`;

const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
`;

const BenefitCard = styled.div`
  background: var(--white);
  padding: 30px;
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;

const BenefitIcon = styled.div`
  color: var(--primary-color);
  font-size: 24px;
  margin-bottom: 20px;
`;

const BenefitTitle = styled.h3`
  font-size: 20px;
  color: var(--dark-color);
  margin-bottom: 15px;
  font-weight: 600;
`;

const BenefitDescription = styled.p`
  color: #666;
  line-height: 1.6;
`;

const benefits = [
  {
    title: 'All-in-One Solution',
    description: 'Replace multiple tools with a single, powerful platform that handles all your marketing needs.'
  },
  {
    title: 'Cost-Effective',
    description: 'Save money by eliminating the need for multiple subscriptions and tools.'
  },
  {
    title: 'Time-Saving',
    description: 'Automate repetitive tasks and streamline your workflow for maximum efficiency.'
  },
  {
    title: 'Easy Integration',
    description: 'Seamlessly integrate with your existing tools and workflows without any hassle.'
  },
  {
    title: 'Scalable Growth',
    description: 'Grow your business with a platform that scales with your needs and ambitions.'
  },
  {
    title: '24/7 Support',
    description: 'Get expert support whenever you need it, with our dedicated customer success team.'
  }
];

const WhySwitch: React.FC = () => {
  return (
    <WhySwitchSection>
      <Container>
        <SectionTitle data-aos="fade-up">
          <h2>Why Make the Switch?</h2>
          <p>Discover why thousands of businesses trust our platform for their marketing needs.</p>
        </SectionTitle>
        <BenefitsGrid>
          {benefits.map((benefit, index) => (
            <BenefitCard key={index} data-aos="fade-up" data-aos-delay={index * 100}>
              <BenefitIcon>
                <FontAwesomeIcon icon={faCheckCircle} />
              </BenefitIcon>
              <BenefitTitle>{benefit.title}</BenefitTitle>
              <BenefitDescription>{benefit.description}</BenefitDescription>
            </BenefitCard>
          ))}
        </BenefitsGrid>
      </Container>
    </WhySwitchSection>
  );
};

export default WhySwitch; 